import { defineProfile } from "./define.js";

export const RESTAURANT_PROFILE = defineProfile("restaurant", {
  labels: ["contacts", "bookings", "products", "orders"],
  home: ["orders_today", "tables_tonight", "unread_chats", "ai_handoffs"],
  kpis: ["orders", "revenue", "bookings", "conversations", "tables_tonight", "ai_handoffs"],
  panel: ["orders", "table_booking", "favorites"],
  quickActions: ["new_order", "book_table"],
  contactFields: [
    {
      key: "delivery_address",
      kind: "text",
      label: { ar: "عنوان التوصيل", en: "Delivery address" },
    },
    {
      key: "favorite_dishes",
      kind: "text",
      label: { ar: "الأطباق المفضلة", en: "Favorite dishes" },
    },
  ],
  aiTools: [
    "search_kb",
    "search_products",
    "create_order",
    "check_order_status",
    "book_slot",
    "escalate",
  ],
  cloudStarterMenu: "food_menu",
  starterPack: "restaurant",
  replyStyle: {
    emoji: "few",
    format: "short_lines",
    greeting: "warm",
    closing: "question",
    length: "brief",
  },
});
